<template>
  <div grid-base>
    <div grid-base-line :class="{ dark, grey, md, alpha50, half, b50, black, side }"/>
    <div grid-base-content>
      <slot/>
    </div>
  </div>
</template>

<script>
export default {
  name: 'GridBase',
  props: {
    dark: { default: false, type: Boolean },
    grey: { default: false, type: Boolean },
    black: { default: false, type: Boolean },
    alpha50: { default: false, type: Boolean },
    b50: { default: false, type: Boolean },
    md: { default: false, type: Boolean },
    half: { default: false, type: Boolean },
    side: { default: false, type: Boolean }
  },
}
</script>

<style lang="less">
@import "~@/less/proj";
[grid-base] { .rel;
  [grid-base-line] { .f; .abs; .-box; .lt;
    &:before { .cnt; .abs; .block; .l(50%); .wh(50%,100%); .-l(#e0e0e0); .-box; opacity: 0.1; }
    &.alpha50:before { opacity: 0.2; }
    &.b50:before { border-color: #e0e0e0; opacity: 0.2; }
    &.dark:before { border-color: #272727; opacity: 1; }
    &.grey:before { border-color: #e0e0e0; opacity: 1; }
    &.black:before { border-color: #e0e0e0; opacity: 0.2; }
    &.half { .hide; }
    &.side { .hide; }
  }
  [grid-base-content] { .rel; }
}

@media (min-width: @screen-md-min) {
  [grid-base] {
    [grid-base-line].md {
      &:before { .l(25%); .w(25%); }
      &.alpha50:after { opacity: 0.2; }
      &:after { .cnt; .abs; .block; .wh(25%, 100%); .l(50%); .-h(#e0e0e0); .-box; opacity: 0.1; }
      &.b50:after { border-color: #e0e0e0; opacity: 0.2; }
      &.dark:after { border-color: #272727; opacity: 1; }
      &.black:after { border-color: #e0e0e0; opacity: 0.2; }
    }
  }
}

@media (min-width: @screen-lg-min) {
  [grid-base] {
    [grid-base-line] {
      &:before { .l(25%); .w(25%); }
      &:after { .cnt; .abs; .block; .wh(25%, 100%); .l(50%); .-h(#e0e0e0); .-box; opacity: 0.1; }
      &.alpha50:after { opacity: 0.2; }
      &.b50:after { border-color: #e0e0e0; opacity: 0.2; }
      &.dark:after { border-color: #272727; opacity: 1; }
      &.grey:after { border-color: #e0e0e0; opacity: 1; }
      &.black:after { border-color: #e0e0e0; opacity: 0.2; }
      &.half { .block;
        &:before { .l(50%); }
        &:after { .hide; }
      }
      &.side { .block;
        &:before { border-color: e0e0e0; opacity: 1; }
        &:after { .-l; border-color: e0e0e0; opacity: 1; }
      }
    }
  }
}
</style>
